export default __webpack_public_path__ + "static/media/beapartwavebtm.1333eba4.png";